<template>
  <div>
    <a-card
      :loading="loading"
      class="mb-4"
      v-if="isAdminMode"
      size="small">
      <div slot="title"><span>{{$t('scope.text_132')}}</span><a-button type="link" slot="extra" icon="upload" @click="dialogVisible = true">{{$t('scope.text_133')}}</a-button></div>
      <div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_134')}}</div>
          <div class="flex-fill">{{ license.license_to || $t('scope.text_135') }}</div>
        </div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_136')}}</div>
          <div class="flex-fill">{{ projectExpire || $t('scope.text_135') }}</div>
        </div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_137')}}</div>
          <div class="flex-fill"><a-tag :color="licStatusC.color">{{ licStatusC.text }}</a-tag></div>
        </div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_138')}}</div>
          <div>
            <div class="flex-fill d-flex" :class="{ 'align-items-end': allSn.length > 1 }">
              <div :class="{ 'border pt-2 pb-2 px-3': allSn.length > 1 }">
                <template v-for="item of sn">
                  <div :key="item" class="mb-2">{{ item }}</div>
                </template>
                <template v-for="item of unAuthServiceNumbers">
                  <div class="mt-2" :key="item">
                    <span>{{ item }}</span>
                    <a-icon class="ml-1 error-color" type="exclamation-circle" />
                  </div>
                </template>
              </div>
              <copy :message="copySn" class="flex-shrink-0 flex-grow-0 ml-2 mt-1" />
            </div>
            <div class="mini-text error-color" v-if="unAuthServiceNumbers && unAuthServiceNumbers.length">{{$t('scope.text_139', [ email ])}}</div>
          </div>
        </div>
        <div class="d-flex">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_140')}}</div>
          <div class="flex-fill">{{ projectCreate || $t('scope.text_135') }}</div>
        </div>
      </div>
    </a-card>
    <a-card
      :loading="licenseLoading"
      class="mb-4"
      size="small"
      v-if="isAdminMode">
      <div slot="title">
        <span>{{$t('scope.text_141')}}</span>
        <a-tooltip slot="extra" placement="left">
          <template slot="title">
            <div>{{$t('scope.text_142')}}</div>
            <div>{{$t('scope.text_143')}}</div>
          </template>
          <a-button type="link" @click="refreshHandle" class="flex-shrink-0">
            <a-icon type="sync" />
          </a-button>
        </a-tooltip>
      </div>
      <license-status-table :status-data="status" />
      <div class="mt-2"><help-link :href="licenseDocsUrl">{{$t('scope.text_144')}}</help-link></div>
    </a-card>
    <a-card
      :title="$t('scope.text_145')"
      size="small">
      <div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_146')}}</div>
          <div class="flex-fill">{{ projectInfo.name || $t('scope.text_135') }}</div>
        </div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_147')}}</div>
          <div class="flex-fill">
            <span>{{ updateItem.current_version || '-' }}</span>
            <a class="ml-2" @click.stop="() => versionsVisible = true">{{$t('scope.text_148')}}</a>
          </div>
        </div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_154')}}</div>
          <div class="flex-fill">
            <a :href="`mailto:${email}`">{{ email }}</a>
            <div class="text-color-help" style="font-size: 12px;">{{$t('scope.text_155')}}</div>
          </div>
        </div>
        <div class="d-flex mb-2">
          <div class="license-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_156')}}</div>
          <div class="flex-fill">{{ copyright }}</div>
        </div>
      </div>
    </a-card>
    <a-drawer
      :title="$t('scope.text_148')"
      placement="right"
      @close="() => versionsVisible = false"
      :visible="versionsVisible"
      width="600px">
      <div
        class="d-flex align-items-center mb-2"
        v-for="item in versions"
        :key="item.service_name">
        <div class="d-flex">
          <div class="version-label flex-grow-0 flex-shrink-0 text-right">{{ item.service_name }}：</div>
          <div class="flex-fill">
            <a-tag :color="item.status === 'active' ? '#87d068' : '#f50'">{{ item.status === 'active' ? $t('scope.text_157') : $t('scope.text_158') }}</a-tag>
            <a-tag>{{ item.version }}</a-tag>
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal
      :title="$t('scope.text_133')"
      :maskClosable="false"
      :visible="dialogVisible"
      @cancel="() => dialogVisible = false">
      <template v-slot:footer>
        <a-button key="submit" type="primary" :loading="uploadLicLoading" @click="uploadLicense">{{$t('scope.text_14')}}</a-button>
        <a-button key="back" @click="() => dialogVisible = false">{{$t('scope.text_152')}}</a-button>
      </template>
      <a-upload-dragger
        name="license"
        :headers="headers"
        :remove="handleRemove"
        :beforeUpload="beforeUpload"
        :fileList="fileList"
        action="/api/v1/licenses">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">{{$t('scope.text_167')}}</p>
        <p class="ant-upload-hint">{{$t('scope.text_168')}}</p>
      </a-upload-dragger>
    </a-modal>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import LicenseStatusTable from './LicenseStatusTable'
import i18n from '@/locales'
import { getRequestT } from '@/utils/utils'

const PROJECT_INFO = {
  compute: {
    name: i18n.t('scope.text_171'),
    id: 'compute',
    limitTip: i18n.t('scope.text_172'),
  },
  servicetree: {
    name: i18n.t('scope.text_173'),
    id: 'servicetree',
    limitTip: i18n.t('scope.text_174'),
  },
  itsm: {
    name: 'itsm',
    id: 'itsm',
    limitTip: i18n.t('scope.text_175'),
  },
}

export default {
  name: 'Licenses',
  components: {
    LicenseStatusTable,
  },
  props: {
    project: {
      type: String,
      default: 'compute',
    },
  },
  data () {
    const validateTime = (rule, value, callback) => {
      const start = this.$moment.now()
      const secs = value.diff(start, 'seconds')
      if (secs <= 0) {
        const msg = this.$t('scope.text_176')
        return callback(msg)
      }
      callback()
    }
    return {
      cancenUpdateConfirmDialog: {
        data: [],
        columns: [
          {
            field: 'current_version',
            title: this.$t('scope.text_177'),
          },
          { field: 'scheduled_version', title: this.$t('scope.text_178') },
          {
            field: 'status',
            title: this.$t('scope.text_119'),
            formatter: ({ row }) => {
              return this.updateStatus[row.status]
            },
          },
        ],
        loading: false,
        visible: false,
      },
      uploadLicLoading: false,
      fileList: [],
      versionsVisible: false,
      loading: false,
      lastMode: undefined,
      dialogVisible: false,
      dialogUpgradeVisible: false,
      versions: [],
      updateInfo: [],
      updateItem: {},
      updateStatus: {
        INIT: this.$t('scope.text_179'),
        IDLE: this.$t('scope.text_180'),
        DOWNLOADING: this.$t('scope.text_181'),
        UPGRADING: this.$t('scope.text_182'),
        WAITING: this.$t('scope.text_183'),
      },
      updateItemStartTime: null,
      versionLoading: false,
      appVersionLoading: false,
      updateLoading: false,
      licenseLoading: false,
      appVersion: this.$t('scope.text_184'),
      cmp: true,
      updateSelectRow: null,
      updateTablePage: {
        total: 0,
        pageSize: 5,
        currentPage: 1,
      },
      updateType: 'default',
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        type: [
          'type',
          {
            initialValue: 'default',
            rules: [
              { required: true, message: this.$t('scope.text_185') },
            ],
          },
        ],
        secs: [
          'secs',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_186') },
              { validator: validateTime },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
      updatesData: [],
    }
  },
  computed: {
    ...mapGetters([
      'isAdminMode',
      'auth',
    ]),
    ...mapState({
      oemInfo: state => state.app.oem,
    }),
    ...mapState({
      license: state => state.app.license.compute,
      serviceNumbers: state => state.app.license.service_numbers,
      status: state => state.app.license.status,
    }),
    email () {
      if (!R.isNil(this.oemInfo.email) && !R.isEmpty(this.oemInfo.email)) {
        return this.oemInfo.email
      }
      return null
    },
    copyright () {
      if (!R.isNil(this.oemInfo.copyright) && !R.isEmpty(this.oemInfo.copyright)) {
        return this.oemInfo.copyright
      }
      return null
    },
    headers () {
      return { Authorization: `Bearer ${this.auth.auth.session}` }
    },
    projectInfo () {
      return PROJECT_INFO[this.project]
    },
    projectFree () {
      const data = this.license
      if (data.expire === 0) {
        return true
      }
      return false
    },
    projectExpire () {
      const data = this.license
      if (data.expire === 0) {
        return this.$t('scope.text_187')
      }
      return this.$moment(data.expire * 1000).format('LL')
    },
    licStatusC () {
      if (this.status.exceeded) {
        return {
          color: '#f50',
          text: this.$t('scope.text_188'),
        }
      } else if (this.status.expired) {
        return {
          color: '#f50',
          text: this.$t('scope.text_189'),
        }
      } else {
        return {
          color: '#87d068',
          text: this.$t('scope.text_190'),
        }
      }
    },
    projectExpired () {
      const data = this.license
      if (data.expire === 0) {
        return false
      }
      const now = new Date()
      return now.getTime() > data.expire * 1000
    },
    projectExpiring () {
      const data = this.license
      if (data.expire === 0) {
        return false
      }
      const now = new Date()
      const diff = data.expire - now.getTime() / 1000
      return diff > 0 && diff < 30 * 24 * 3600
    },
    projectCreate () {
      const data = this.license
      if (data.create_time === 0) {
        return this.$t('scope.text_187')
      }
      return this.$moment(data.create_time * 1000).format('LL')
    },
    expireTitle () {
      const data = this.license
      const currentTime = +new Date()
      let title = this.$t('scope.text_191')
      if (currentTime < data.expire * 1000 || data.expire === 0) {
        title = this.$t('scope.text_192')
        return title
      }
      return title
    },
    sn () {
      const sn = this.license.sn
      if (R.is(String, sn)) {
        return [sn]
      }
      return sn || []
    },
    showUpdateBadge () {
      return this.updateInfo.some(item => item.updateAvailable)
    },
    unAuthServiceNumbers () {
      if (this.serviceNumbers && R.type(this.serviceNumbers) === 'Array') {
        return this.serviceNumbers.filter(item => !this.sn.includes(item))
      }
      return []
    },
    allSn () {
      if (this.sn && R.type(this.sn) === 'Array') {
        const ret = this.sn.concat(this.unAuthServiceNumbers)
        return ret
      }
      return []
    },
    copySn () {
      return this.allSn.join('\n')
    },
    licenseDocsUrl () {
      return `${window.location.origin}/docs/${this.$language}/docs/admin/license`
    },
  },
  destroyed () {
    this.manager = null
    this.updateManager = null
    this.versionManager = null
    clearTimeout(this.updateTimer)
  },
  created () {
    this.manager = new this.$Manager('licenses', 'v1')
    this.updateManager = new this.$Manager('updates', 'v1')
    this.versionManager = new this.$Manager('versions', 'v1')
    // this.getLicenses()
    this.getServiceVersions()
    // this.getAppVersion()
  },
  methods: {
    getUpdates () {
      this.updateManager.list({
        params: {
          $t: getRequestT(),
        },
      }).then(res => {
        this.updatesData = res.data.data || []
      })
    },
    getUpdateInfo () {
      this.updateManager.list({
        params: {
          $t: getRequestT(),
          limit: 0,
          full: true,
          // limit: this.updateTablePage.pageSize,
          // offset: (this.updateTablePage.currentPage === 1 ? 0 : this.updateTablePage.currentPage - 1) * this.updateTablePage.pageSize,
        },
      }).then(res => {
        if (res.data.total >= 1) {
          this.updateInfo = res.data.data || []
          if (this.updateInfo.length > 0) {
            this.updateSelectRow = this.updateInfo[0]
          }
          this.updateTablePage.total = res.data.total
        }
      })
    },
    async getUpdateItem () {
      try {
        const response = await this.updateManager.list({
          params: {
            $t: getRequestT(),
            status: true,
          },
        })
        const data = response.data.data || []
        if (data.length > 0) {
          this.updateItem = data[0]
          this.updateItemStartTime = this.$moment().add('seconds', this.updateItem.secs).format()
        }
      } catch (error) {
        throw error
      }
    },
    getAppVersion () {
      this.appVersionLoading = true
      this.versionManager.get({ id: 'cloud' }).then(res => {
        const data = res.data || ''
        this.appVersion = data
        this.appVersionLoading = false
      }).catch(() => {
        this.appVersionLoading = false
      })
    },
    getServiceVersions () {
      this.versionLoading = true
      this.versionManager.list().then(res => {
        const data = res.data.data || []
        this.versions = data
        this.versionLoading = false
      }).catch(() => {
        this.versionLoading = false
      })
    },
    async getLicenses (payload) {
      this.licenseLoading = true
      try {
        await this.$store.dispatch('app/fetchLicense', { ...payload })
      } catch (error) {
        throw error
      } finally {
        this.licenseLoading = false
      }
    },
    waitUpdateStatus (time) {
      clearTimeout(this.updateTimer)
      return new Promise((resolve, reject) => {
        this.updateTimer = setTimeout(() => {
          this.updateManager.list({
            params: {
              status: true,
              $t: getRequestT(),
            },
          }).then(res => {
            const data = (res.data.data || [])[0]
            if (!R.isNil(data) && !R.isEmpty(data)) {
              if (data.status === 'IDLE') {
                resolve(true)
              } else {
                resolve(false)
              }
            } else {
              reject(new Error(this.$t('scope.text_194', [this.updateSelectRow.tag])))
            }
          }).catch(error => {
            reject(error)
          })
        }, time)
      })
    },
    async startWait () {
      try {
        const status = await this.waitUpdateStatus(3000)
        if (status) {
          this.updateLoading = false
          await this.$store.dispatch('auth/logout')
          this.$router.push({ name: 'Auth' })
          window.location.reload()
        } else {
          this.startWait()
        }
      } catch (error) {
        this.startWait()
      }
    },
    successTip () {
      this.$message.success(this.$t('scope.text_195'))
      window.location.reload()
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    async uploadLicense () {
      this.uploadLicLoading = false
      try {
        const file = this.fileList[0]
        if (!file) {
          this.$message.warning(this.$t('scope.text_196'))
          return
        }
        if (file.size > 10240) {
          this.$message.warning(this.$t('scope.text_197'))
          return
        }
        if (!file.name.endsWith('.lic')) {
          this.$message.warning(this.$t('scope.text_198'))
          return
        }
        const fd = new FormData()
        fd.append('license', file)
        await this.manager.create({
          data: fd,
        })
        this.successTip()
      } catch (error) {
        throw error
      }
    },
    updateRadioChangeEvent ({ row }) {
      this.updateSelectRow = row
    },
    openUpdateDialogHandle () {
      this.dialogUpgradeVisible = true
      this.$nextTick(() => {
        this.updateType = 'default'
        this.form.fc.resetFields()
        this.$refs.table.refreshColumn()
        if (this.updateInfo && this.updateInfo.length) {
          this.$refs.table.setRadioRow(this.updateInfo[0])
        }
      })
    },
    handleUpdatePageChange ({ currentPage }) {
      this.updateTablePage.currentPage = currentPage
      this.getUpdateInfo()
    },
    updateDisabledDate (currentDate) {
      return currentDate.valueOf() < Date.now() - 8.64e7
    },
    handleUpdateTypeChange (e) {
      this.updateType = e.target.value
    },
    updateRadioCheckMethod ({ row }) {
      if (this.updateLoading) return row.tag === this.updateSelectRow.tag
      return true
    },
    handleOpenCancelUpdate () {
      this.cancenUpdateConfirmDialog.visible = true
      this.cancenUpdateConfirmDialog.data = [this.updateItem]
    },
    async doCancelUpdate () {
      this.cancenUpdateConfirmDialog.loading = true
      try {
        await this.updateManager.create({
          params: {
            $t: getRequestT(),
          },
          data: {
            cancel: true,
          },
        })
        this.cancenUpdateConfirmDialog.visible = false
        this.getUpdateInfo()
        setTimeout(() => {
          this.getUpdateItem()
        }, 1)
      } catch (error) {
        throw error
      } finally {
        this.cancenUpdateConfirmDialog.loading = false
      }
    },
    refreshHandle () {
      // this.getLicenses({ refresh: true })
    },
  },
}
</script>

<style lang="less" scoped>
.license-label {
  width: 120px;
}
.version-label {
  width: 120px;
}
.release-notes {
  max-height: 100px;
  overflow: hidden;
  overflow-y: auto;
  background-color: rgba(242, 242, 242, 0.4);
  border: 1px solid #ddd;
  padding: 0 10px;
  color: #aaa;
  :global(h2) {
    font-size: 16px;
    margin: 5px 0;
  }
  :global(h3) {
    font-size: 14px;
    margin: 5px 0;
  }
  :global(ul) {
    margin-bottom: 10px;
  }
}
</style>
